// Generated via oats. Do NOT modify manually.

import * as t from 'io-ts';
import {excess} from '@fl/cmsch-fe-library';

// @ts-ignore: Workaround for "is declared but its value is never read."
import { EarTag, EarTagSchema } from 'api/gen/EarTag';

const requiredPart = t.interface({
  breedingFemalesEarTags: t.union([t.array(EarTagSchema), t.null]),
});

export const BreedingFemalesEarTagsSchema = excess(requiredPart);

export interface BreedingFemalesEarTags extends t.TypeOf<typeof BreedingFemalesEarTagsSchema> {}
